'use client';

import { cn } from '@reelplicate/ui/lib/utils';
import { Label as LabelPrimitive } from 'radix-ui';
import * as React from 'react';

/** shadcn Label, restyled to Figma Label/Medium in text/primary. */
function Label({
  className,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        'text-label-md text-text-primary flex items-center gap-2 select-none',
        'group-data-[disabled=true]:pointer-events-none peer-disabled:cursor-not-allowed',
        className,
      )}
      {...props}
    />
  );
}

export { Label };
